import { render, staticRenderFns } from "./transporte.vue?vue&type=template&id=12f6c7d0"
import script from "./transporte.ts?vue&type=script&lang=js&external"
export * from "./transporte.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f6c7d0')) {
      api.createRecord('12f6c7d0', component.options)
    } else {
      api.reload('12f6c7d0', component.options)
    }
    module.hot.accept("./transporte.vue?vue&type=template&id=12f6c7d0", function () {
      api.rerender('12f6c7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/importacaonfe/transporte.vue"
export default component.exports